// Small display formatters shared by the Jobs list and detail cards.

/**
 * The backend's one-line address when the payload has it. Otherwise the parts,
 * joined in the same order the backend writes formatted_address (AS-919):
 * "line1, line2, city, ST ZIP". The calendar API still sends only the parts.
 */
export const formatAddress = (address) => {
  if (!address) return "";
  if (typeof address === "string") return address;
  if (address.formatted_address) return address.formatted_address;
  const line1 = address.line1 || address.address_line1;
  const line2 = address.line2 || address.address_line2;
  const stateZip = [address.state, address.zip || address.zip_code]
    .filter(Boolean)
    .join(" ");
  return [line1, line2, address.city, stateZip].filter(Boolean).join(", ");
};

/**
 * Format an amount as USD with grouped thousands, or "" when absent.
 * Amounts arrive as numbers or as decimal strings ("1000000.00") from the API;
 * cents are shown only when the amount actually has them.
 */
export const formatMoney = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const amount = Number(value);
  if (!Number.isFinite(amount)) return `$${value}`;
  const cents = Math.round(amount * 100) % 100 !== 0 ? 2 : 0;
  return `$${amount.toLocaleString("en-US", {
    minimumFractionDigits: cents,
    maximumFractionDigits: cents,
  })}`;
};
